import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class DynamicBodyAttribute extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.DYNAMIC_BODY, t.to('動く 重さ:', 'dynamic_body'));
    this.setNameForCode('dynamic-body');
  }
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setPhysicsSystemColor(block);

    // const shape = new Blockly.FieldDropdown([
    //   [t.to('直方体', 'dynamic_body_box'), 'box'],
    //   [t.to('球体', 'dynamic_body_sphere'), 'sphere'],
    //   [t.to('3D', 'dynamic_body_auto'), '3d'],
    // ]);

    const mass = new Blockly.FieldTextInput('5');
    ShapeSettings.setTitleField(block, this.title);
    block
      .appendDummyInput()
      .appendField(mass, 'mass')
      .appendField(t.to('キロ', 'dynamic_body_mass'));
    // block
    //   .appendDummyInput()
    //   .appendField(t.to('形状', 'dynamic_body_shape') + ':')
    //   .appendField(shape, 'shape');
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const mass = CodeSetting.getFieldValue(block, 'mass');
    const sceneStr = `( scene ? scene:document.querySelector("a-scene")).setAttribute("physics","driver: ammo; debug: false  ; debugDrawMode: 1;friction:0");`;
    const str = CodeSetting.buildAttribute(
      [
        ['autofit-ammo', `type:dynamic;mass:${mass};`],
        ['class', 'clickable collidable'],
        ['push', 'power:10'],
      ],
      attribute
    );
    return [str + sceneStr];
  }
}
